import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeAgo',
  pure: false
})
export class TimeAgoPipe implements PipeTransform, OnDestroy {
  private timer: number;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService
  ) {}

  transform(value: string) {
    this.removeTimer();
    const d = new Date(value);
    const now = new Date();
    const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000));
    const timeToUpdate = this.getSecondsUntilUpdate(seconds) * 1000;

    const minutes = Math.round(Math.abs(seconds / 60));
    const hours   = Math.round(Math.abs(minutes / 60));
    const days    = Math.round(Math.abs(hours / 24));
    const months  = Math.round(Math.abs(days / 30.416));
    const years   = Math.round(Math.abs(days / 365));
    // this.translate.instant('offers.list.heading')
    if (seconds <= 45) {
      return this.translate.instant('shared.date.ago.seconds');
    } else if (seconds <= 90) {
      return this.translate.instant('shared.date.ago.minutes', { minutes: 1 });
    } else if (minutes <= 45) {
      return this.translate.instant('shared.date.ago.minutes', { minutes: minutes });
    } else if (minutes <= 90) {
      return this.translate.instant('shared.date.ago.hours', { hours: 1 });
    } else if (hours <= 22) {
      return this.translate.instant('shared.date.ago.hours', { hours: hours });
    } else if (hours <= 36) {
      return this.translate.instant('shared.date.ago.days', { days: 1 });
    } else if (days <= 25) {
      return this.translate.instant('shared.date.ago.days', { days: days });
    } else if (days <= 45) {
      return this.translate.instant('shared.date.ago.months', { months: 1 });
    } else if (days <= 345) {
      return this.translate.instant('shared.date.ago.months', { months: months });
    } else if (days <= 545) {
      return this.translate.instant('shared.date.ago.years', { years: 1 });
    } else {
      return this.translate.instant('shared.date.ago.years', { years: years });
    }
  }
  ngOnDestroy(): void {
    this.removeTimer();
  }

  private removeTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  private getSecondsUntilUpdate(seconds: number) {
    const min = 60;
    const hr = min * 60;
    const day = hr * 24;
    if (seconds < min) {
      return 2;
    } else if (seconds < hr) {
      return 30;
    } else if (seconds < day) {
      return 300;
    } else {
      return 3600;
    }
  }
}
